import fromArea from './from-area-animation'
import fromBar from './from-bar-animation'
import fromPie from './from-pie-animation'
import splitLine from './split-line-animation'
import unsplitLine from './unsplit-lines-animation'
import addBreakdown from '../../animations/add-breakdown-animation'
import removeBreakdown from '../../animations/remove-breakdown-animation'
import sliding from '../../animations/sliding-animation'
import entering from '../../animations/entering-animation'
import exiting from '../../animations/exiting-animation'
import basic from '../../animations/basic-animation' // Run last which will simply update the line

const Animations = [
  fromArea,
  fromBar,
  fromPie,
  splitLine,
  unsplitLine,
  addBreakdown,
  removeBreakdown,
  sliding,
  entering,
  exiting,
  basic,
]

/*
 * Basic lines can use the common line-area animations with a single LineAdjuster for adjusting the path
 */
export default Animations
